"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Sum = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 10,
  height: 14,
  viewBox: "0 0 10 14"
}, props), _react.default.createElement("path", {
  d: "M9.022 0c.54 0 .976.448.976 1a.992.992 0 01-.862.993L9.022 2H3.457l4.249 4.051c.373.356.412.94.108 1.343l-.083.097L3.331 12h5.691c.5 0 .913.386.97.883l.006.117a.992.992 0 01-.862.993L9.022 14H.976C.144 14-.29 13.014.21 12.377l.075-.084 5.35-5.484L.31 1.732C-.31 1.14.056.092.867.006L.976 0h8.046z",
  className: "fill"
}));

var _default = Sum;
exports.default = _default;